import React from 'react';
import {
  FilterBadgeCount,
  FilterButton,
  FilterCount,
  FilterDropdown,
  FilterMenu,
  FilterOption,
  FilterSection,
  FilterSectionLabel
} from './ScriptTranslationView.styles';
import type { FilterKey } from './useTranslationScript';

export type StatusCounts = {
  missing: number;
  stale: number;
  manual: number;
  auto: number;
};

export type MediaCounts = {
  audio: number;
  video: number;
  image: number;
};

export type TranslationFiltersProps = {
  filtersOpen: boolean;
  setFiltersOpen: (open: boolean | ((prev: boolean) => boolean)) => void;
  activeFilters: Set<FilterKey>;
  toggleFilter: (key: FilterKey) => void;
  statusCounts: StatusCounts;
  mediaCounts: MediaCounts;
};

export const TranslationFilters: React.FC<TranslationFiltersProps> = ({
  filtersOpen,
  setFiltersOpen,
  activeFilters,
  toggleFilter,
  statusCounts,
  mediaCounts
}) => {
  return (
    <FilterDropdown data-filter-dropdown>
      <FilterButton type="button" onClick={() => setFiltersOpen(o => !o)}>
        <span>Filters</span>
        {activeFilters.size > 0 && (
          <FilterBadgeCount>{activeFilters.size}</FilterBadgeCount>
        )}
      </FilterButton>
      {filtersOpen && (
        <FilterMenu>
          <FilterSection>
            <FilterSectionLabel>Translation Status</FilterSectionLabel>
            <FilterOption>
              <input
                type="checkbox"
                checked={activeFilters.has('missing')}
                onChange={() => toggleFilter('missing')}
              />
              Missing <FilterCount>({statusCounts.missing})</FilterCount>
            </FilterOption>
            <FilterOption>
              <input
                type="checkbox"
                checked={activeFilters.has('stale')}
                onChange={() => toggleFilter('stale')}
              />
              Outdated <FilterCount>({statusCounts.stale})</FilterCount>
            </FilterOption>
            <FilterOption>
              <input
                type="checkbox"
                checked={activeFilters.has('manual')}
                onChange={() => toggleFilter('manual')}
              />
              Manually translated{' '}
              <FilterCount>({statusCounts.manual})</FilterCount>
            </FilterOption>
            <FilterOption>
              <input
                type="checkbox"
                checked={activeFilters.has('auto')}
                onChange={() => toggleFilter('auto')}
              />
              Auto translated <FilterCount>({statusCounts.auto})</FilterCount>
            </FilterOption>
          </FilterSection>
          <FilterSection>
            <FilterSectionLabel>Media Type</FilterSectionLabel>
            <FilterOption>
              <input
                type="checkbox"
                checked={activeFilters.has('hasAudio')}
                onChange={() => toggleFilter('hasAudio')}
              />
              Audios <FilterCount>({mediaCounts.audio})</FilterCount>
            </FilterOption>
            <FilterOption>
              <input
                type="checkbox"
                checked={activeFilters.has('hasVideo')}
                onChange={() => toggleFilter('hasVideo')}
              />
              Videos <FilterCount>({mediaCounts.video})</FilterCount>
            </FilterOption>
            <FilterOption>
              <input
                type="checkbox"
                checked={activeFilters.has('hasImages')}
                onChange={() => toggleFilter('hasImages')}
              />
              Images <FilterCount>({mediaCounts.image})</FilterCount>
            </FilterOption>
          </FilterSection>
        </FilterMenu>
      )}
    </FilterDropdown>
  );
};
